module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJtMSA1LjQzNiAyLjI2NiAzLjE4N2ExIDEgMCAwIDAgMS43MzctLjE5NEw4LjExIDFoMCIgc3Ryb2tlPSIjMDA3OEE3IiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/checkmark-lili-blue.svg
// module id = MAa+
// module chunks = 27